import { useFormContext } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { AmenityPicker } from "@/components/AmenityPicker/AmenityPicker";
import type { WizardValues } from "./schema";

const CARE_OPTIONS = ["prenatal", "postnatal"] as const;
const CARE_LABELS: Record<string, string> = {
  prenatal: "Prenatal",
  postnatal: "Postnatal",
};

export const FacilityStep = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<WizardValues>();
  const careTypes = watch("careTypes") ?? [];
  const amenityIds = watch("amenityIds") ?? [];

  const toggleCare = (c: (typeof CARE_OPTIONS)[number]) => {
    const set = new Set(careTypes as string[]);
    if (set.has(c)) set.delete(c);
    else set.add(c);
    setValue("careTypes", Array.from(set) as any, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <div className="space-y-6">
      <div>
        <Label>
          Care types<span className="text-destructive ml-0.5">*</span>
        </Label>
        <div className="flex gap-2 mt-1.5">
          {CARE_OPTIONS.map((c) => {
            const on = (careTypes as string[]).includes(c);
            return (
              <button
                key={c}
                type="button"
                onClick={() => toggleCare(c)}
                className={`px-3 py-1.5 text-sm rounded-btn border ${
                  on
                    ? "bg-primary text-primary-foreground border-primary"
                    : "bg-background border-border text-muted-foreground"
                }`}
              >
                {CARE_LABELS[c] ?? c}
              </button>
            );
          })}
        </div>
        {errors.careTypes ? (
          <p className="text-xs text-destructive mt-1">
            {errors.careTypes.message as string}
          </p>
        ) : null}
      </div>

      <div>
        <Label>
          Amenities<span className="text-destructive ml-0.5">*</span>
        </Label>
        <div className="mt-2">
          <AmenityPicker
            value={amenityIds as string[]}
            onChange={(next) =>
              setValue("amenityIds", next, {
                shouldValidate: true,
                shouldDirty: true,
              })
            }
          />
        </div>
        {errors.amenityIds ? (
          <p className="text-xs text-destructive mt-1">
            {errors.amenityIds.message as string}
          </p>
        ) : null}
      </div>
    </div>
  );
};
